import { AboutUs } from './AboutUs'
import { BanquetMain } from './BanquetMain/BanquetMain'
import { BookTable } from './BookTable'
import { Contacts } from './Contacts'
import { Decoration } from './Decoration'
import { Main } from './Main'
import { OtherRestaurants } from './OtherRestaurants'
import { OurKitchen } from './OurKitchen'

export const Layout = {
  Main,
  BookTable,
  AboutUs,
  OurKitchen,
  OtherRestaurants,
  Contacts,
  Decoration,
  BanquetMain,
}
